import { InjectionToken } from '@angular/core';


export interface DatabaseService<T> {  
  create(tableName: string, record: Partial<T>): Promise<T>;
  getAll(tableName: string): Promise<T[]>;
  getById(tableName: string, id: number | string): Promise<T | null>;
  update(tableName: string, id: number | string, updates: Partial<T>): Promise<T>;
  delete(tableName: string, id: number | string): Promise<void>;
}

export const DATABASE_SERVICE = new InjectionToken<DatabaseService<any>>('DATABASE_SERVICE');